import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { EssayWritingIllustration } from './EssayWriting';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const EssayWriting = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <EssayWritingIllustration title={title} />
  </IllustrationWrapper>
);
